var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-with-buttons',{attrs:{"options":[
                         {value: 1, text: 1, class: ['scoreButton']},
                         {value: 2, text: 2, class: ['scoreButton']},
                         {value: 3, text: 3, class: ['scoreButton']},
                         {value: 4, text: 4, class: ['scoreButton']},
                         {value: 5, text: 5, class: ['scoreButton']},
                         {value: 6, text: 6, class: ['scoreButton']},
                         {value: 7, text: 7, class: ['scoreButton']},
                         {value: 0, text: _vm.$t('calls.pass'), size: 2, class: ['pass']}
                     ],"row-size":"4"},on:{"click":_vm.propagateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }